export const root = '/work';

export const invoices = `${root}/invoices`;
export const quotes = `${root}/quotes`;
export const clients = `${root}/clients`;
export const catalog = `${root}/catalog`;

export const getInvoice = (id: string) => `${invoices}/${id}`;
export const getQuote = (id: string) => `${quotes}/${id}`;
export const getClient = (id: string) => `${clients}/${id}`;

export const previewInvoice = `${invoices}/:invoiceId?`;
export const previewQuote = `${quotes}/:quoteId?`;

export const addInvoice = `${invoices}/add`;
export const addQuote = `${quotes}/add`;

export const editInvoice = `${invoices}/:invoiceId/edit`;
export const editQuote = `${quotes}/:quoteId/edit`;

export const legacyEditInvoice = `${invoices}/edit/:invoiceId?`;
export const legacyEditQuote = `${quotes}/edit/:quoteId?`;

export const getEditInvoice = (id: string) => `${invoices}/${id}/edit`;
export const getEditQuote = (id: string) => `${quotes}/${id}/edit`;
